import { render } from "./Bncc.vue?vue&type=template&id=5a13bca2&scoped=true"
import script from "./Bncc.vue?vue&type=script&lang=ts"
export * from "./Bncc.vue?vue&type=script&lang=ts"

import "./Bncc.vue?vue&type=style&index=0&id=5a13bca2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a13bca2"

export default script